import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ADPConfigService,LabelResource, Resource, SitefinitySetting, ADPResourceService, NotificationService, CustomFormControl } from "digital-core";
import { PGHAPIService } from "src/app/core/services/pgh-api-service";
import { HeaderDetail } from "src/app/model/HeaderDetail";
import { ImportResource } from "src/app/model/sitefinity/ImportResource";

declare global {
  interface Navigator {
      msSaveBlob?: (blob: any, defaultName?: string) => boolean
  }
}

@Component({
  selector: "gssp-export",
  templateUrl: "./cms.component.html",
  styleUrls: ["./cms.component.scss"],
})
export class CMSComponent implements OnInit {

  labelArray: LabelResource[] = [];
  formResourceArray: ImportResource[] = [];
  settingsArray: SitefinitySetting[] = [];
  isEnglish = false;
  HideParents = true;
  result = "";
  error = "";
  filterBy = "";

  public form = new FormGroup({
		Test: new CustomFormControl()
	});
  public cloneForm = new FormGroup({
		TargetSitefinityId: new CustomFormControl(),
    TargetSitefinityLanguages: new CustomFormControl()
	});

  constructor(
    public resourceService: ADPResourceService,
    public configService: ADPConfigService,
    public pghApiService: PGHAPIService,
    public notificationService: NotificationService,
    public activatedRoute: ActivatedRoute,
    public router: Router
  ) {

    this.isEnglish = this.configService.language.toLocaleLowerCase() === 'en';
    this.activatedRoute.queryParams.subscribe(params => {
      if(params['clearcache'] == 'current') {
        this.resourceService.clearSiteResource().subscribe(response => {
          this.router.navigate(['/']);

        });
      }
      if(params['clearcache'] == 'all') {
        this.resourceService.clearCache().subscribe(response => {
          this.router.navigate(['/']);
        });
      }
    });
  }

  ngOnInit() {

      if (this.resourceService.labels) {
        Object.entries(this.resourceService.labels).forEach((element) => {
          this.labelArray.push(element[1] as LabelResource);
        });
      }
      this.labelArray = this.labelArray.sort((a, b) => (a.ResourceKey > b.ResourceKey) ? 1 : -1);


      if (this.resourceService.settings) {
        Object.entries(this.resourceService.settings).forEach((element) => {
          this.settingsArray.push(element[1] as SitefinitySetting);
        });
      }
      this.settingsArray = this.settingsArray.sort((a, b) => (a.Title > b.Title) ? 1 : -1);

      if (this.resourceService.resources) {
        Object.entries(this.resourceService.resources).forEach((element) => {
          let res = element[1] as Resource;
          let inputRes = new ImportResource();
          inputRes.Title = res.Title;
          inputRes.PlaceHolder = res.PlaceHolder;
          inputRes.ValidationMessage = res.ValidationMessage;
          inputRes.Hint = res.Hint;
          inputRes.ToolTip = res.ToolTip;
          inputRes.S = res.S;
          this.formResourceArray.push(inputRes);
        });
      }
      this.formResourceArray = this.formResourceArray.sort((a, b) => (a.Title > b.Title) ? 1 : -1);
      if(this.isEnglish)
        this.cloneForm.get('TargetSitefinityLanguages').setValue("en");
      else
        this.cloneForm.get('TargetSitefinityLanguages').setValue("en,"+this.configService.language);

        this.cloneForm.get('TargetSitefinityId').setValue('449a57fc-2519-4719-9af0-5b13fe998893');

  }

  getResourceObject(title: string) {
    let resourceValue = this.resourceService.getViewResourceObject(title);
    return resourceValue;
  }

  downloadContent() {
    this.exportToCsv(this.configService.getClientName() +'-' +  'Contents-'+ this.configService.language +  '.csv', this.labelArray);
  }

  downloadResource() {
    this.exportToCsv(this.configService.getClientName() +'-' +  'Resources-'+ this.configService.language +  '.csv', this.formResourceArray);
  }

  exportToCsv(filename: string, rows: object[]) {
    filename = filename.toUpperCase();
    if (!rows || !rows.length) {
      return;
    }
    const separator = ',';
    const keys = Object.keys(rows[0]);
    const csvContent =
      keys.join(separator) +
      '\n' +
      rows.map(row => {
        return keys.map(k => {
          let cell = row[k] === null || row[k] === undefined ? '' : row[k];
          cell = cell instanceof Date
            ? cell.toLocaleString()
            : cell.toString().replace(/"/g, '""');
          if (cell.search(/("|,|\n)/g) >= 0) {
            cell = `"${cell}"`;
          }
          return cell;
        }).join(separator);
      }).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  cloneMenus(){
    this.result = this.error = "";
    const customHeaders: HeaderDetail[] = [];
    this.pghApiService.publicPostWithHeaders<object, string>(
      'resource/cloneMenus?targetSiteId='+this.cloneForm.get('TargetSitefinityId').value
      +'&targetLanguageList='+this.cloneForm.get('TargetSitefinityLanguages').value,
      null,
      customHeaders
      ).subscribe(
        (res) => {
          this.result  = res;
        },
        (error: any) => {
          this.error  = "Error: " + error.error.error.message;
        });;
  }


  cloneSettings(){
    this.result = this.error = "";
    this.pghApiService.publicPost<object, string>(
      'resource/cloneSettings?targetSiteId='+this.cloneForm.get('TargetSitefinityId').value,
      null,
      ).subscribe(
        (res) => {
          this.result  = res;
        },
        (error: any) => {
          this.error  = "Error: " + error.error.Message;
        });;
  }

  cloneContent(){
    this.result = this.error = "";
    const customHeaders: HeaderDetail[] = [];
    this.pghApiService.publicPostWithHeaders<object, string>(
      'resource/cloneLabels?targetSiteId='+this.cloneForm.get('TargetSitefinityId').value
      +'&targetLanguageList='+this.cloneForm.get('TargetSitefinityLanguages').value,
      null,
      customHeaders
    ).subscribe(
      (res) => {
        this.result  = res;
      },
      (error: any) => {
        this.error  = "Error: " + error.error.Message;
      });;
  }

  cloneResources(){
    this.result = this.error = "";
    const customHeaders: HeaderDetail[] = [];
    this.pghApiService.publicPostWithHeaders<object, string>(
      'resource/cloneResources?targetSiteId='+this.cloneForm.get('TargetSitefinityId').value
      +'&targetLanguageList='+this.cloneForm.get('TargetSitefinityLanguages').value,
      null,
      customHeaders
      ).subscribe(
        (res) => {
          this.result  = res;
        },
        (error: any) => {
          this.error  = "Error: "  + error.error.Message;
        });;
  }

  cloneLists(){
    this.result = this.error = "";
    const customHeaders: HeaderDetail[] = [];
    this.pghApiService.publicPostWithHeaders<object, string>(
      'resource/cloneLists?targetSiteId='+this.cloneForm.get('TargetSitefinityId').value
      +'&targetLanguageList='+this.cloneForm.get('TargetSitefinityLanguages').value,
      null,
      customHeaders
      ).subscribe(
        (res) => {
          this.result  = res;
        },
        (error: any) => {
          this.error  = "Error: "  + error.error.Message;
        });;
  }

  cloneImages() {
    this.result = this.error = "";
    this.pghApiService.publicPost<object, string>(
      'resource/cloneImages?targetSiteId='+this.cloneForm.get('TargetSitefinityId').value,
      null,
      ).subscribe(
        (res) => {
          this.result  = res;
        },
        (error: any) => {
          this.error  = "Error: " + error.error.Message;
        });;
  }

  toggleDeveloperMode() {
    this.resourceService.isEditMode = !this.resourceService.isEditMode;
  }


}

